import {FC, InputHTMLAttributes, useState} from 'react'
import {IProductCardType, IDisplayedField} from "./IProductCardOptionType";
import {IFormFieldProps} from "../../IFormFieldProps";
import ProductCardChoiceItem from "./ProductCardChoiceItem";
import FieldErrorMessage from "../messages/FieldErrorMessage";
import {updateElementTimestamp} from '../../../../store/element/elements';
import {useAppDispatch, useAppSelector} from '../../../../store/hook';
import Element from '../../../../domain/Element/Element';
import getElementsIdToRender from '../../../util/getElementsIdToRender';
import SaveUseCase from '../../../../domain/Form/SaveUseCase';
import FormGateway from '../../../../gateway/Form/FormGateway';

interface IProps extends InputHTMLAttributes<HTMLInputElement>, IFormFieldProps {
    products?: IProductCardType[],
    displayedFields?: IDisplayedField[],
    id: string,
    defaultValue?: string,
    handleChangeForParent?: (newValue: string) => void,
    name: string
}

const ProductCardChoiceList: FC<IProps> = (
    {
        products,
        displayedFields,
        id,
        label,
        defaultValue,
        classes,
        error,
        register,
        handleChangeForParent,
        ...rest
    }) => {

    const dispatch = useAppDispatch()

    const elementsWithConditionJSON = useAppSelector(state => state.elements.currentElementsWithCondition)
    const elementsWithCondition: Element[] = JSON.parse(elementsWithConditionJSON)
    const elementsWithCalculeJSON = useAppSelector(state => state.elements.currentElementsWithCalcule)
    const elementsWithCalcule: Element[] = JSON.parse(elementsWithCalculeJSON)
    const elementsWithReferenceJSON = useAppSelector(state => state.elements.currentElementsWithReference)
    const elementsWithReference: Element[] = JSON.parse(elementsWithReferenceJSON)

    const [value, setValue] = useState<string | undefined>(defaultValue);

    const handleChange = (newValue: string) => {
        setValue(newValue);

        if (typeof handleChangeForParent !== 'undefined') {
            handleChangeForParent(newValue)
        }

        const data: Array<string> = [];
        data[id] = newValue;
        const saveUseCase = new SaveUseCase(new FormGateway())
        saveUseCase.execute(data).then(() => {
            const elementsIdToRender: string[] = getElementsIdToRender(
                elementsWithCondition,
                id,
                elementsWithCalcule,
                elementsWithReference
            )
            elementsIdToRender.map(
                elementIdToRender => dispatch(
                    updateElementTimestamp({'id': elementIdToRender})
                )
            )
        })
    };

    return (
        <div className={`${classes} ${rest.readOnly ? "readonly-element" : ""}`}>
            {label &&
                <p className="u-txt-size-l u-txt-color-text-light u-mbb">{label}</p>}

            <div className="flex-container" title={rest.help}>
                {products?.map(product => (
                    <ProductCardChoiceItem
                        key={product.code}
                        product={product}
                        displayedFields={displayedFields ?? []}
                        checked={product.code === value}
                        name={id}
                        onChange={handleChange}
                        disabled={rest.readOnly || rest.disabled}
                        register={register}
                    />
                ))}

                {error?.message && <FieldErrorMessage message={error.message}/>}
            </div>
        </div>
    )
};

export default ProductCardChoiceList;
